import React from 'react';

interface TikTokIconProps {
  className?: string;
}

const TikTokIcon: React.FC<TikTokIconProps> = ({ className = "h-5 w-5" }) => {
  return (
    <img 
      src="/tiktok-logo.png" 
      alt="TikTok" 
      className={className}
    />
  );
};

export default TikTokIcon;